<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 10:58:53
 * @LastEditTime: 2020-06-15 14:20:33
 * @Description: 考生考试信息
 -->
<template>
  <div class="examinee-info">
    <table>
      <tbody>
        <tr>
          <td class="category">姓名：
            <span>{{ examineeInfo.userName }}</span>
          </td>
          <td class="category">账号：
            <span>{{ examineeInfo.userCode }}</span>
          </td>
        </tr>
        <tr>
          <td class="category">身份明细：
            <span>{{ examineeInfo.userType }}</span>
          </td>
          <td class="category">分公司：
            <span>{{ examineeInfo.branchName }}</span>
          </td>
          <td class="category">办事处：
            <span>{{ examineeInfo.subBranchName }}</span>
          </td>
        </tr>
        <tr>
          <td class="category">分数：
            <span>{{ examineeInfo.score }}</span>
          </td>
          <td class="category">全国排名：
            <span>{{ examineeInfo.rank }}</span>
          </td>
          <td class="category">分公司排名：
            <span>{{ examineeInfo.branchRank }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ExamineeInfo',
  props: {
    examineeInfo: { type: Object, required: true },
  },
};
</script>

<style lang="less" scoped>
.examinee-info {
  width: 100%;

  > table {
    width: 100%;

    > tbody {
      width: 100%;

      > tr {
        width: 100%;
        height: 42px;
        border-bottom: 1px solid #ddd;

        > td {
          width: calc(100% / 3);
          vertical-align: middle;
          font-size: 12px;

          &.category {
            font-weight: bold;

            > span {
              font-weight: normal;
            }

            > a {
              margin-right: 16px;

              &:last-of-type {
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
